export function buildPhotoLink(template: string, photo: string) {
  return template.replace("{params}", "w_300").replace("{image}", photo);
}
